module.exports = __webpack_public_path__ + "img/property4.95af1b0e.png";